export function disableBodyScroll() {
  document.body.style.overflow = 'hidden';
}

export function enableBodyScroll() {
  document.body.style.overflow = 'auto';
}
